if (!customElements.get('pdp-image-with-text')) {
  class PDPImageWithText extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this), 250);
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;

      this.style.setProperty(
        '--pdp-image-with-text-desktop-gap',
        `${this.dataset.desktopGap || 40}px`
      );
      this.style.setProperty(
        '--pdp-image-with-text-desktop-spacing',
        `${this.dataset.itemSpacing || 56}px`
      );
      this.style.setProperty(
        '--pdp-image-with-text-radius',
        `${this.dataset.imageRadius || 12}px`
      );

      this.setAttribute('loaded', '');
    }
  }

  customElements.define('pdp-image-with-text', PDPImageWithText);
}